// extracted by mini-css-extract-plugin
export default {"page":"styles_page__R0R5r","text":"styles_text__3idUg"};